var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"custom-tooltip",style:(_vm.overlayStyle)},[_vm._t("default",function(){return [_c('div')]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }